// extracted by mini-css-extract-plugin
export default {"featureBox":"features-tag_featureBox__S2o0M","text":"features-tag_text__5HxnT","featDetail":"features-tag_featDetail__TYdPC"};